<template>
    <div class="factoring-shipper-list">
      <h2 class="title">
        Shippers pending approval
      </h2>

      <shipper-approvals />

    </div>
</template>

<script>
import ShipperApprovals from '@/components/FactoringApprovalsShipperTable'
export default {
  name: 'Factoring',

  components: {
    ShipperApprovals
  }
}
</script>

<style scoped lang="scss">
.factoring-shipper-list {
  min-height: 85vh;
  &::after {
    // TODO: this would be great as a mix-in
    content: '';
    background-image: url('../../assets/backgrounds/shutterstock_1017037816.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    opacity: 0.4;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: fixed;
    z-index: -1;
  }
}
.button {
  margin: 0 16px;
}
</style>
